export const getAuthorizationCredentialsQueryKey = (professionalId: string) =>
  ['GET_AUTHORIZATION_CREDENTIALS', { professionalId }] as const;
